import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatButtonModule, MatCardModule, MatMenuModule, MatToolbarModule, MatIconModule, MatTableModule
  , MatSidenavModule, MatListModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, MatSlideToggleModule,
  MatTabsModule, MatProgressSpinnerModule, MatRadioModule, MatStepperModule, MatCheckboxModule, MatDialogModule
} from '@angular/material';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { SharedModule } from './_modules/shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import {WebcamModule} from 'ngx-webcam';
import {
  NgxUiLoaderModule, NgxUiLoaderConfig
  , SPINNER, POSITION, NgxUiLoaderRouterModule
} from 'ngx-ui-loader';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import {

  AppComponent, HomeComponent, HeaderComponent, DeclarationsComponent, TermsAndConditionsComponent, DocumentAttachmentComponent,
  DaoDropdownComponent, DaoSwitchComponent, DaoTexboxComponent, OtpComponent, DaoCounterDirective, DaoDialogComponent, TestComponent,
  CameraDialogComponent,
  BaseService, LookupService, MinuteSecondsPipe, EmailCheckGuard,LandingComponent,BreadcrumbComponent

} from './index';

import { JsonAppConfigService, AppConfig } from './_config';
import { DaoButtonComponent } from './directives/dao-button/dao-button.component';


const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsPosition: POSITION.bottomRight,
  bgsType: SPINNER.cubeGrid, // background spinner type
  fgsType: SPINNER.cubeGrid, // foreground spinner type
  fgsColor: 'white',
  bgsColor:'blue',
  overlayBorderRadius: "0",
  overlayColor: "rgba(40, 40, 40, 0.8)",
   //blur:10,
  // overlayColor: 'grey',
  // hasProgressBar:false
};


export function initializerFn(jsonAppConfig: JsonAppConfigService) {
  return () => {
    return jsonAppConfig.load();
  };
}


@NgModule({
  declarations: [
    TestComponent,
    AppComponent,
    HomeComponent,
    HeaderComponent,
    DeclarationsComponent,
    TermsAndConditionsComponent,
    MinuteSecondsPipe,
    DocumentAttachmentComponent,DaoDropdownComponent,DaoSwitchComponent,DaoTexboxComponent, OtpComponent, DaoCounterDirective, DaoDialogComponent, DaoButtonComponent, LandingComponent, 
    BreadcrumbComponent, CameraDialogComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,

    NgxUiLoaderRouterModule,
    MatButtonModule,
    MatCardModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    FlexLayoutModule,
    MatTabsModule,
    MatCheckboxModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    SharedModule, MatTableModule, MatSlideToggleModule, MatProgressSpinnerModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    WebcamModule
  ],
  providers: [
    BaseService,
    EmailCheckGuard,
    LookupService,
    {
      provide: AppConfig,
      deps: [HttpClient],
      useExisting: JsonAppConfigService
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [JsonAppConfigService],
      useFactory: initializerFn
    }
  ],
  entryComponents: [
    DaoDialogComponent,
    CameraDialogComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
